$(document).ready(function() {
    var currentPageUrl = window.location.pathname;

    // Define the levels you want to include
    var levels = ['.x-menu--level-1--link', '.x-menu--level-2--link', '.x-menu--level-3--link'];
    
    // Loop through each level
    levels.forEach(function(level) {
        $(level).each(function () {
            var linkHref = $(this).find('a').attr('href');
    
            // Check if the href matches the current page URL
            if (currentPageUrl === linkHref) {
                $(this).addClass('active');
            }
    
            setTimeout(function() {
                    // Check if the specific class exists on a child element
                    if ($(this).find('.active').length > 0) {
                        // Add the 'active-child' class to the closest of the element with 'active'
                        $(this).closest('.x-menu--level-1--link').addClass('active-child');
                    }
                }.bind(this), 50);
        });
    });
});
